function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #959595;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "precio",
  className: "cls-1",
  d: "M1155.036,912.2a10.211,10.211,0,1,0,10.211,10.211A10.212,10.212,0,0,0,1155.036,912.2Zm.357,15.92c-2.2,0-3.641-1.267-3.9-3.856h-.383c-.438,0-.717-.231-.717-.621s.271-.622.717-.622h.319v-1.036h-.319c-.438,0-.717-.231-.717-.621s.271-.63.717-.63h.375c.239-2.462,1.7-3.9,3.919-3.9,1.944,0,3.7,1.37,3.7,2.861a.932.932,0,0,1-.91,1.012c-.389,0-.645-.247-.876-.637a1.951,1.951,0,0,0-1.84-1.347c-1.06,0-1.673.7-1.808,2.016h1.768c.447,0,.725.231.725.63s-.278.621-.725.621h-1.872v1.036h1.872c.447,0,.725.223.725.622s-.278.621-.725.621h-1.768c.127,1.3.724,1.969,1.848,1.969a1.884,1.884,0,0,0,1.888-1.3c.223-.406.463-.654.884-.654.542,0,.861.422.861,1.012C1159.147,926.884,1157.354,928.119,1155.394,928.119Z",
  transform: "translate(-1144.825 -912.199)"
});

function SvgEuro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.423,
    height: 20.423,
    viewBox: "0 0 20.423 20.423",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuro);
export default __webpack_public_path__ + "static/media/euro.6b8bf9a5.svg";
export { ForwardRef as ReactComponent };